import React from "react";
import img from "../../../../groupe_pages/PMT/img/img_v2/IMG-20220428-WA0012.jpg";

const Feature = ({ icon, title, text }) => (
  <div className="ut-feature">
    <div className="ut-feature-icon">{icon}</div>
    <h4>{title}</h4>
    <p>{text}</p>
  </div>
);

const Title = ({ small, big }) => (
  <div className="ut-title">
    <span>{small}</span>
    <h2>{big}</h2>
  </div>
);

export default function UsTextilePage() {
  return (
    <div className="ut-page">

      {/* HERO */}
      <section className="ut-hero">
        <div className="ut-hero-img">
          <img src={img} alt="US Textile plafond" />
        </div>

        <div className="ut-hero-content">
        <div className="us-badge" ><h3 ><span className="subtitle-us">US</span> <b>TEXTILE</b></h3></div>
          <h1>Plafonds & Murs Tendus Textile à Froid</h1>

          <p>
            Solution professionnelle en toile textile polyester posée à froid.
            Écologique, acoustique et lumineuse, idéale pour les espaces
            modernes : bureaux, restaurants, hôtels et commerces.
          </p>

          <div className="ut-hero-buttons">
            <a className="btn-primarya" href="/devis">Demander un devis</a>
            <a href="pdf/fichetechniquelatoile-2.pdf"download className="btn-outline">Télécharger la fiche technique</a>
            
          </div>
        </div>
      </section>

      {/* DESCRIPTION */}
      <section className="ut-section">
        <Title
          small="Présentation"
          big="Qu’est-ce que la solution US TEXTILE ?"
        />

        <div className="ut-two-cols">
          <p>
            US TEXTILE est un système de plafond et mur tendu en toile
            polyester technique thermorétractable. Contrairement au PVC,
            l’installation se fait à froid, sans chauffage, ce qui rend la pose
            plus rapide et plus sûre.
          </p>

          <p>
            Cette solution combine design, performance acoustique et diffusion
            lumineuse. Elle est parfaitement adaptée aux projets architecturaux
            exigeants et aux environnements recevant du public.
          </p>
        </div>
      </section>

      {/* AVANTAGES */}
      <section className="ut-section ut-gray">
        <Title small="Atouts" big="Avantages principaux" />

        <div className="ut-grid">
          <Feature icon="❄️" title="Pose à froid" text="Installation sans chauffage ni contrainte thermique." />
          <Feature icon="🌿" title="Écologique" text="Textile certifié, faible impact environnemental." />
          <Feature icon="🔊" title="Acoustique" text="Excellente absorption sonore avec isolant." />
          <Feature icon="🧽" title="Lavable" text="Nettoyage simple et entretien facile." />
          <Feature icon="🎨" title="Impression HD" text="Visuels personnalisés grand format." />
          <Feature icon="💡" title="Lumineux" text="Compatible rétro-éclairage et lightbox." />
        </div>
      </section>

      {/* FINITIONS */}
      <section className="ut-section">
        <Title small="Design" big="Finitions & variantes" />

        <div className="ut-tags">
          {[
            "Mat premium",
            "Imprimé HD",
            "Acoustique",
            "Translucide",
            "Rétro-éclairé",
            "Grande largeur",
            "Antibactérien",
            "Décoratif",
          ].map(t => <span key={t}>{t}</span>)}
        </div>
      </section>

      

      {/* TECHNIQUE */}
      <section className="ut-section">
        <Title small="Technique" big="Caractéristiques techniques" />

        <ul className="ut-list ut-wide">
          <li>Toile polyester haute résistance</li>
          <li>Profilés aluminium discrets</li>
          <li>Large laize = moins de joints</li>
          <li>Classement feu B-s1,d0</li>
          <li>Certification Oeko-Tex (selon gamme)</li>
          <li>Perméable à l’air</li>
          <li>Compatible LED & caissons lumineux</li>
        </ul>
      </section>

      {/* PROCESS */}
      <section className="ut-section ut-gray">
        <Title small="Méthode" big="Processus d’installation" />

        <div className="ut-steps">
          {[
            "Étude & mesures",
            "Fabrication textile",
            "Pose profilés",
            "Tension à froid",
            "Découpes techniques",
            "Intégration lumière/acoustique",
            "Contrôle final",
          ].map((s, i) => (
            <div key={s} className="ut-step">
              <div className="ut-step-num">{i + 1}</div>
              <p>{s}</p>
            </div>
          ))}
        </div>
      </section>

      {/* CTA */}
      <section className="ut-cta">
        <h2>Intégrer US TEXTILE dans votre projet</h2>
        <p>Notre équipe technique vous accompagne de l’étude à la pose.</p><br/>
        <a href="/contact" className="btn-primarya">Contact nos</a>
      </section>

    </div>
  );
}